import { render, staticRenderFns } from "./organizations-by-type-widget.vue?vue&type=template&id=450be614&scoped=true&"
import script from "./organizations-by-type-widget.vue?vue&type=script&lang=js&"
export * from "./organizations-by-type-widget.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-type-widget.vue?vue&type=style&index=0&id=450be614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450be614",
  null
  
)

export default component.exports